// extracted by mini-css-extract-plugin
var _1 = "PdfPreview-modulePdfPreview__r1jH9";
var _2 = "PdfPreview-moduleskeleton__UEiga Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "PdfPreview", _2 as "skeleton" }
